__turbopack_context__.v({
  "applied": "eGllwG_applied",
  "container": "eGllwG_container",
  "icon": "eGllwG_icon",
});
